<template>
  <div ref="focusTarget" class="container pad">
    <h2 class="question-title">Velg en avatar</h2>
    <div class="avatars">
      <div class="avatars-item" :class="{ active: select == 'male', 'avatars-item-disable': select != 'male' && avatar != '' && avatar.sex != 'male' }">
        <div @click="pick('male')" class="avatar-toggle"><img :src="getDefaultImage('male')" /></div>
        <transition name="fade">
          <div class="avatar-item-list" v-if="select == 'male'">
            <label class="avatar-item-list-item" :class="avatar.icon == image.icon ? 'current' : ''" v-for="(image, i) in male" :key="`m${i}`" :for="`male-${i}`">
              <input v-model="avatar" :id="`male-${i}`" name="avatar" type="radio" :value="image" />
              <img :src="image.icon" alt="" />
            </label>
          </div>
        </transition>
      </div>

      <div class="avatars-item" :class="{ active: select == 'female', 'avatars-item-disable': select != 'female' && avatar != '' && avatar.sex != 'female' }">
        <div @click="pick('female')" class="avatar-toggle"><img :src="getDefaultImage('female')" /></div>
        <transition name="fade">
          <div class="avatar-item-list" v-if="select == 'female'">
            <label class="avatar-item-list-item" :class="avatar.icon == image.icon ? 'current' : ''" v-for="(image, i) in female" :key="`f${i}`" :for="`female-${i}`">
              <input v-model="avatar" :id="`female-${i}`" name="avatar" type="radio" :value="image" />
              <img :src="image.icon" alt="" />
            </label>
          </div>
        </transition>
      </div>
    </div>
    <div ref="btnnext">
      <transition name="fader">
        <a href="#" @click="startQuiz" @touchstart.prevent="startQuiz" class="btn btn--red next-question" v-if="avatar != ''">Neste steg</a>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  mounted() {
    if (this.avatar != '') {
      this.select = this.avatar.sex
    }
  },
  data() {
    return {
      male: [
        { sex: 'male', icon: require('@/src/assets/man-1.svg') },
        { sex: 'male', icon: require('@/src/assets/man-2.svg') },
        { sex: 'male', icon: require('@/src/assets/man-3.svg') }
      ],
      female: [
        { sex: 'female', icon: require('@/src/assets/lady-1.svg') },
        { sex: 'female', icon: require('@/src/assets/lady-2.svg') },
        { sex: 'female', icon: require('@/src/assets/lady-3.svg') }
      ],
      select: '',
      timeout: null,
      hide: false
    }
  },

  watch: {
    // whenever question changes, this function will run
    avatar: function (newAvatar, oldAvatar) {
      this.avatar = this.avatar
      this.sex = this.avatar.sex
      this.select = ''
      const el = this.$refs['btnnext']
      if (el) {
        setTimeout(function () {
          el.scrollIntoView()
        }, 200)
      }
    }
  },
  computed: {
    ...mapFields(['sex', 'avatar'])
  },
  methods: {
    pick(sex) {
      this.select = sex
      if (this.avatar == '') {
        this.avatar = this[sex][0]
        this.$nextTick(function () {
          this.select = sex
        })
      }
    },
    startQuiz() {
      this.timeout = setTimeout(() => {
        this.$router.push({ path: '/1' })
      }, 100)
    },
    getDefaultImage(sex) {
      if (this.avatar.sex == sex) {
        return this.avatar.icon
      } else {
        return this[sex][0].icon
      }
    }
  }
}
</script>

<style lang="scss">
.container.pad {
  padding-bottom: 250px;
}
.avatar-item-list {
  img {
    max-width: 56px;
    max-height: 85px;
  }
}
.avatars-item {
  input {
    display: none;
  }
}

.avatar-item-list,
.fade-enter-active,
.fade-leave-active {
  transition: all 0.25s ease;
}
.fade-enter {
  opacity: 0;
  -webkit-transform: translate(10vw, 0);
  transform: translate(10vw, 0);
}
.fade-leave-active {
  opacity: 0;
  -webkit-transform: translate(-10vw, 0);
  transform: translate(-10vw, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Avatar.vue